// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  padding: 20px;
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Custom styles for the access control system */
.sidebar-expanded .MuiCollapse-root {
  background-color: rgba(0, 0, 0, 0.04);
}

.permission-chip {
  margin: 2px !important;
}

.data-grid-container {
  height: 600px;
  width: 100%;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.stats-card {
  transition: transform 0.2s ease-in-out;
}

.stats-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.activity-item {
  border-left: 3px solid #1976d2;
  padding-left: 12px;
  margin-bottom: 8px;
}

.success-activity {
  border-left-color: #4caf50;
}

.error-activity {
  border-left-color: #f44336;
}

/* Responsive design */
@media (max-width: 600px) {
  .data-grid-container {
    height: 400px;
  }
}

/* Glammify Logo Responsive Styling */
.merchant-layout img[alt="Glammify Logo"] {
  max-width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  min-width: 0;
  flex-shrink: 0;
  min-height: 40px;
}

.merchant-layout .logo-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  width: 100%;
  flex-shrink: 1;
  min-width: 0;
}

@media (max-width: 600px) {
  .merchant-layout img[alt="Glammify Logo"] {
    max-height: 60px;
    width: auto;
  }
  
  .merchant-layout .logo-container {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .merchant-layout img[alt="Glammify Logo"] {
    max-height: 55px;
    width: auto;
  }
  
  .merchant-layout .logo-container {
    max-width: 100%;
  }
}

@media (max-width: 360px) {
  .merchant-layout img[alt="Glammify Logo"] {
    max-height: 50px;
    width: auto;
  }
  
  .merchant-layout .logo-container {
    max-width: 100%;
  }
}

@media (min-width: 601px) and (max-width: 960px) {
  .merchant-layout img[alt="Glammify Logo"] {
    max-height: 55px;
    width: auto;
  }
}

@media (min-width: 961px) {
  .merchant-layout img[alt="Glammify Logo"] {
    max-height: 60px;
    width: auto;
  }
}

/* Ensure logo is never too small on any device */
@media (max-width: 320px) {
  .merchant-layout img[alt="Glammify Logo"] {
    max-height: 45px;
    width: auto;
  }
  
  .merchant-layout .logo-container {
    max-width:90%;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .activity-item {
    border-left-color: #90caf9;
  }
  
  .success-activity {
    border-left-color: #81c784;
  }
  
  .error-activity {
    border-left-color: #e57373;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gDAAgD;AAChD;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  padding: 20px;\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Custom styles for the access control system */\n.sidebar-expanded .MuiCollapse-root {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.permission-chip {\n  margin: 2px !important;\n}\n\n.data-grid-container {\n  height: 600px;\n  width: 100%;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n.stats-card {\n  transition: transform 0.2s ease-in-out;\n}\n\n.stats-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.activity-item {\n  border-left: 3px solid #1976d2;\n  padding-left: 12px;\n  margin-bottom: 8px;\n}\n\n.success-activity {\n  border-left-color: #4caf50;\n}\n\n.error-activity {\n  border-left-color: #f44336;\n}\n\n/* Responsive design */\n@media (max-width: 600px) {\n  .data-grid-container {\n    height: 400px;\n  }\n}\n\n/* Glammify Logo Responsive Styling */\n.merchant-layout img[alt=\"Glammify Logo\"] {\n  max-width: 100%;\n  height: auto;\n  object-fit: contain;\n  display: block;\n  min-width: 0;\n  flex-shrink: 0;\n  min-height: 40px;\n}\n\n.merchant-layout .logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  overflow: hidden;\n  width: 100%;\n  flex-shrink: 1;\n  min-width: 0;\n}\n\n@media (max-width: 600px) {\n  .merchant-layout img[alt=\"Glammify Logo\"] {\n    max-height: 60px;\n    width: auto;\n  }\n  \n  .merchant-layout .logo-container {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .merchant-layout img[alt=\"Glammify Logo\"] {\n    max-height: 55px;\n    width: auto;\n  }\n  \n  .merchant-layout .logo-container {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 360px) {\n  .merchant-layout img[alt=\"Glammify Logo\"] {\n    max-height: 50px;\n    width: auto;\n  }\n  \n  .merchant-layout .logo-container {\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 601px) and (max-width: 960px) {\n  .merchant-layout img[alt=\"Glammify Logo\"] {\n    max-height: 55px;\n    width: auto;\n  }\n}\n\n@media (min-width: 961px) {\n  .merchant-layout img[alt=\"Glammify Logo\"] {\n    max-height: 60px;\n    width: auto;\n  }\n}\n\n/* Ensure logo is never too small on any device */\n@media (max-width: 320px) {\n  .merchant-layout img[alt=\"Glammify Logo\"] {\n    max-height: 45px;\n    width: auto;\n  }\n  \n  .merchant-layout .logo-container {\n    max-width:90%;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .activity-item {\n    border-left-color: #90caf9;\n  }\n  \n  .success-activity {\n    border-left-color: #81c784;\n  }\n  \n  .error-activity {\n    border-left-color: #e57373;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
